"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerPaymentVolumeTransport = exports.HaulerPaymentVolumeQuery = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.HaulerPaymentVolumeQuery = typebox_1.Type.Object({
    since: typebox_1.Type.String({ format: 'date-time' }),
});
exports.HaulerPaymentVolumeTransport = typebox_1.Type.Object({
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    since: typebox_1.Type.String({ format: 'date-time' }),
    until: typebox_1.Type.String({ format: 'date-time' }),
    amount: typebox_1.Type.Integer(),
});
//# sourceMappingURL=hauler-payment-volume.js.map